$(function () {
  $(".helpSectionHeader").click( function() {
    $(".helpSection").collapse("hide");
  })
});
